import { redirect } from '@tanstack/react-router';
import { getTokenAndExpire, isTokenExpired, TOKEN, TOKEN_EXPIRES } from 'src/helpers/authHelper';

// Check if user has a valid token
export const isAuthenticated = (): boolean => {
  const tokenData = getTokenAndExpire();
  const token = tokenData[TOKEN];
  const tokenExpires = tokenData[TOKEN_EXPIRES];

  if (!token) {
    return false;
  }

  // Check if token is expired
  if (tokenExpires && isTokenExpired(Number(tokenExpires))) {
    return false;
  }

  return true;
};

// Guard for routes that require authentication
export const requireAuth = (): void => {
  if (!isAuthenticated()) {
    throw redirect({
      to: '/login',
      search: {
        redirect: window.location.pathname,
      },
    });
  }
};

// Guard for routes that should only be accessible when NOT authenticated (login page)
export const requireGuest = (): void => {
  if (isAuthenticated()) {
    throw redirect({
      to: '/library',
    });
  }
};

// Guard for admin-only routes
export const requireAdmin = (userRole?: string): void => {
  requireAuth();
  if (userRole !== 'ADM') {
    throw redirect({
      to: '/library',
    });
  }
};

// Guard for manager or admin routes
export const requireManagerOrAdmin = (userRole?: string): void => {
  requireAuth();
  if (userRole !== 'ADM' && userRole !== 'MGR') {
    throw redirect({
      to: '/library',
    });
  }
};
